module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "on-clickaway",
      rawName: "v-on-clickaway",
      value: (_vm.onClose),
      expression: "onClose"
    }],
    staticClass: "dropdown",
    class: {
      collapsed: _vm.collapsed
    }
  }, [_c('div', {
    staticClass: "dropdown__btn",
    class: _vm.btnClass,
    on: {
      "click": _vm.onToggle
    }
  }, [_vm._t("btn")], 2), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "dropdown"
    }
  }, [(_vm.collapsed) ? _c('div', {
    staticClass: "dropdown__content"
  }, [_c('button', {
    staticClass: "btn btn--mobile-close",
    on: {
      "click": _vm.onClose
    }
  }, [_c('span', {
    staticClass: "icon-remove"
  })]), _vm._v(" "), _vm._t("content")], 2) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6f33deb8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/DropdownSimple.vue
// module id = 442
// module chunks = 2